/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalCreateFormInstanceResponseAllOfFormInstance } from './SupplementalCreateFormInstanceResponseAllOfFormInstance';
import {
    SupplementalCreateFormInstanceResponseAllOfFormInstanceFromJSON,
    SupplementalCreateFormInstanceResponseAllOfFormInstanceFromJSONTyped,
    SupplementalCreateFormInstanceResponseAllOfFormInstanceToJSON,
} from './SupplementalCreateFormInstanceResponseAllOfFormInstance';

/**
 * 
 * @export
 * @interface SupplementalCreateFormInstanceResponseAllOf
 */
export interface SupplementalCreateFormInstanceResponseAllOf {
    /**
     * 
     * @type {SupplementalCreateFormInstanceResponseAllOfFormInstance}
     * @memberof SupplementalCreateFormInstanceResponseAllOf
     */
    form_instance?: SupplementalCreateFormInstanceResponseAllOfFormInstance;
}

/**
 * Check if a given object implements the SupplementalCreateFormInstanceResponseAllOf interface.
 */
export function instanceOfSupplementalCreateFormInstanceResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalCreateFormInstanceResponseAllOfFromJSON(json: any): SupplementalCreateFormInstanceResponseAllOf {
    return SupplementalCreateFormInstanceResponseAllOfFromJSONTyped(json, false);
}

export function SupplementalCreateFormInstanceResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalCreateFormInstanceResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_instance': !exists(json, 'form_instance') ? undefined : SupplementalCreateFormInstanceResponseAllOfFormInstanceFromJSON(json['form_instance']),
    };
}

export function SupplementalCreateFormInstanceResponseAllOfToJSON(value?: SupplementalCreateFormInstanceResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_instance': SupplementalCreateFormInstanceResponseAllOfFormInstanceToJSON(value.form_instance),
    };
}

